<template>
  <FormPanel
      headline="Create Content Topic Article"
      :errors="errors"
      :portal="portal"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentTopicArticles/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-topic-articles', {...data, content_topic_id: this.$route.params.contentTopicId})
          .then(() => {
            notify.success('The primary menu link child was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/topics/' + this.$route.params.contentTopicId + '/edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
